import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FourOhFourComponent } from './four-oh-four.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'four-oh-four',
        component: FourOhFourComponent
      },
      {
        path: '**',
        redirectTo: 'four-oh-four'
      }
    ])
  ],
  exports: [RouterModule]
})
export class FourOhFourRoutingModule {}
